import { sanitizeStandardSection, sanitizeDescription } from './renderHtml';
import type { SectionElement } from './Gallery/types';
import { ArcGisImage } from './Gallery/ArcGisImage';
import styles from './SectionPreview.module.css';

interface PreviewForm {
    tittel: string;
    tekst: string;
    infoboks?: boolean;
}

interface SectionPreviewProps {
    form: PreviewForm;
    elements?: SectionElement[];
}

export function SectionPreview({ form, elements }: SectionPreviewProps) {
    const hasContent = form.tittel || form.tekst;

    if (!hasContent) {
        return (
            <div className={styles.empty}>
                Forhåndsvisning vises her når du fyller inn innhold.
            </div>
        );
    }

    return (
        <div className={form.infoboks ? styles.infoboks : styles.card}>
            {form.tittel && (
                <h2 className={styles.tittel}>{form.tittel}</h2>
            )}
            {form.tekst && (
                <div
                    className={styles.tekst}
                    dangerouslySetInnerHTML={{ __html: sanitizeStandardSection(form.tekst) }}
                />
            )}
            {elements && elements.length > 0 && (
                <div className={styles.elements}>
                    {[...elements]
                        .sort((a, b) => a.prioritet - b.prioritet)
                        .map((el, i) => (
                            <figure key={el.id ?? i} className={styles.element}>
                                {el.imageUrl && (
                                    !!el._persistUri
                                        ? <ArcGisImage src={el.imageUrl} alt={el.title} className={styles.elementImg} />
                                        : <img src={el.imageUrl} alt={el.title} className={styles.elementImg} />
                                )}
                                <figcaption className={styles.elementCaption}>
                                    {el.title && (
                                        <strong className={styles.elementTitle}>{el.title}</strong>
                                    )}
                                    {el.description && (
                                        <div
                                            className={styles.elementDescription}
                                            dangerouslySetInnerHTML={{ __html: sanitizeDescription(el.description) }}
                                        />
                                    )}
                                </figcaption>
                            </figure>
                        ))}
                </div>
            )}
        </div>
    );
}
